import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define the API base URL
const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api/";
// const BEARER_TOKEN= process.env.;

export const settingsApi = createApi({
  reducerPath: "settingsApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  tagTypes: ["Settings"],
  endpoints: (builder) => ({
    // Get settings by aamarId
    settings: builder.query({
      query: (aamarId) => ({
        url: `settings/${aamarId}`,
        method: "GET",
      }),
      providesTags: ["Settings"],
    }),

    // Generate API key for e-commerce integration
    generateApiKey: builder.query({
      query: ({ aamarId }) => ({
        url: `ecom/generateKey/${aamarId}`,
        method: "GET",
      }),
      providesTags: ["Settings"],
    }),

    // Add or update settings
    addSettings: builder.mutation({
      query: (body) => ({
        url: `settings`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Settings"],
    }),

    // Update specific settings section
    updateSettings: builder.mutation({
      query: ({ aamarId, settingsData }) => ({
        url: `settings/update/${aamarId}`,
        method: "PUT",
        body: settingsData,
      }),
      invalidatesTags: ["Settings"],
    }),

    // Delete settings
    deleteSettings: builder.mutation({
      query: (aamarId) => ({
        url: `settings/delete/${aamarId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Settings"],
    }),
  }),
});

// Export hooks for usage in components
export const {
  useSettingsQuery,
  useGenerateApiKeyQuery,
  useAddSettingsMutation,
  useUpdateSettingsMutation,
  useDeleteSettingsMutation,
} = settingsApi;

// Default export for the store configuration
export default settingsApi;
